/** "15 minutes", "2 hours", "1 day 6 hours". */
export function inactivityPhrase(minutes: number): string {
  const units: [number, string, string][] = [
    [Math.floor(minutes / (24 * 60)), "day", "days"],
    [Math.floor((minutes % (24 * 60)) / 60), "hour", "hours"],
    [minutes % 60, "minute", "minutes"],
  ];
  const parts = units
    .filter(([count]) => count > 0)
    .map(([count, one, many]) => `${count} ${count === 1 ? one : many}`);
  return parts.length === 0 ? "0 minutes" : parts.join(" ");
}
